export default __webpack_public_path__ + "d0f18a7faf657f807b7642c8e105ca20.ogg";